import {FiArrowLeft} from "react-icons/fi";
import {Link, Location} from "react-router";

import {IconButton} from "@/components/iconButton/IconButton.tsx";

import styles from "./MetricsExplorerTitle.module.scss";

interface MetricsExplorerTitleProps {
  /** The page that opened the explorer, when it said so. */
  backTo?: Location;
}

export const MetricsExplorerTitle = ({backTo}: MetricsExplorerTitleProps) => (
  <div className={styles.title}>
    {backTo && (
      <IconButton
        icon={FiArrowLeft}
        iconProps={{size: "large"}}
        variant="ghost"
        size="fitIcon"
        as={Link}
        to={backTo}
        aria-label="Back"
        title="Back"
      />
    )}
    Metrics Explorer
  </div>
);
